const MessageTypes = require('../message-types');

module.exports.setOnline = (socket, isOnline) => {
  const timestamp = new Date().toISOString().replace("T", "").split(".")[0];
  socket.emit(MessageTypes.UPDATE_STATUS, {
    userData: {
      status: isOnline ? `online:${timestamp}` : `offline:${timestamp}`
    }
  });
};

module.exports.setFocusedRoom = (socket, focusedRoom) => {
  socket.emit(MessageTypes.UPDATE_STATUS, {
    userData: {
      focusedRoom: focusedRoom
    },
  });
};



// WEBPACK FOOTER //
// ../node_modules/@flic-chat/js-sdk/src/api/status.js